import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Components/Header';
import styles from '../Styles/Layout.module.css';

export default function Layout() {
    return (
        <div className={styles.wrapper}>
            <Header /> {/* always on screen */}
            <main className={styles.main}>
                {' '}
                {/* every page goes here */}
                <Outlet />
            </main>
        </div>
    );
}
